import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

import styles from "./collapsableSection.module.css";

const CollapsableSection = ({
  isOpen,
  onClose,
  title,
  content,
  actions,
  bodyHeight,
  background = "white",
  actionShow = false,
  // May 2026 redesign: when true, hide the chevron, disable the
  // click-to-collapse behavior, and always render the body fully open.
  // Default false preserves the legacy collapsable behavior.
  noCollapse = false,
}) => {
  const effectiveOpen = noCollapse ? true : isOpen;
  return (
    <div
      className={`${styles.collapsable_comp} ${effectiveOpen ? "" : styles.close}`}
      style={{ backgroundColor: background }}
    >
      <div
        className={`${styles.comp_header} ${
          actions?.length === 0 ? styles.no_btn : ""
        }`}
        onClick={noCollapse ? undefined : onClose}
        style={noCollapse ? { cursor: "default" } : undefined}
      >
        <p className={styles.comp_heading}>{title}</p>

        <div className={styles.comp_actions}>
          {Array.isArray(actions) && actions.length > 0 && (
            <div
              className={`${styles.actions_wrapper} ${
                actionShow && !effectiveOpen ? styles.actions_show_when_closed : ""
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              {React.Children.map(actions, (action) =>
                React.isValidElement(action)
                  ? React.cloneElement(action, {
                      className: `${styles.action} ${
                        action.props["data-selected"] ? styles.selected : ""
                      }`
                    })
                  : action
              )}
            </div>
          )}

          {!noCollapse && (
            <FontAwesomeIcon className={styles.drop_icon} icon={faChevronDown} />
          )}
        </div>
      </div>

      <div
        className={styles.comp_body}
        style={{ height: effectiveOpen ? bodyHeight : "0px" }}
      >
        {content}
      </div>
    </div>
  );
};

export default CollapsableSection;
